import React from 'react';
import css from './ShippingDetailsForm.module.css';
import { FieldMultiSelect, FieldTextInput, Icons } from '../../../components';
import { useIntl } from 'react-intl';
import { required } from '../../../util/validators';
import { Field } from 'react-final-form';
import { distanceUnitOptions, weightUnitEnum } from '../../../config/configExtras';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import classNames from 'classnames';

const PackageDimensionSection = ({ formId, heading }) => {
  const intl = useIntl();

  const fields = [
    { name: 'length', type: 'number', autoComplete: 'given-name', messageId: 'length' },
    { name: 'width', type: 'number', autoComplete: 'given-name', messageId: 'width' },
    { name: 'height', type: 'number', autoComplete: 'given-name', messageId: 'height' },
    { name: 'weight', type: 'number', autoComplete: 'given-name', messageId: 'weight' },
  ];

  const renderField = ({ name, type, autoComplete, messageId }) => (
    <div className={css.formFld} key={name}>
      <FieldTextInput
        type={type}
        id={formId ? `${formId}.${name}` : name}
        name={name}
        autoComplete={autoComplete}
        label={intl.formatMessage({ id: `ShippingDetailsForm.${messageId}` })}
        placeholder={intl.formatMessage({ id: `ShippingDetailsForm.${messageId}Placeholder` })}
        validate={required(intl.formatMessage({ id: `ShippingDetailsForm.${messageId}Required` }))}
      />
    </div>
  );

  const renderUnitField = (name, options, labelId, requiredId, tooltipId) => {
    const tooltipDomId = `${formId || 'pkg'}.${name}-tooltip`;
    return (
      <div className={css.formFld} key={name}>
        <Field
          name={name}
          label={
            <>
              {intl.formatMessage({ id: `ShippingDetailsForm.${labelId}` })}
              <span data-tooltip-id={tooltipDomId}>
                <Icons name="info" />
              </span>
            </>
          }
          component={FieldMultiSelect}
          options={options}
          isMulti={false}
          validate={required(intl.formatMessage({ id: `ShippingDetailsForm.${requiredId}` }))}
          placeholder={intl.formatMessage({ id: 'ShippingDetailsForm.selectPlaceholder' })}
        />
        <ReactTooltip
          id={tooltipDomId}
          place="top"
          effect="solid"
          content={intl.formatMessage({ id: `ShippingDetailsForm.${tooltipId}` })}
        />
      </div>
    );
  };

  return (
    <div className={css.section}>
      {heading}

      {/* Dimensions row */}
      <div className={classNames(css.formRow, css.formRowDimension)}>
        {[['length', 'width'], ['height']].map((pair, idx) => (
          <React.Fragment key={`dim-block-${idx}`}>
            {pair.map(fieldName => {
              const field = fields.find(f => f.name === fieldName);
              return field ? renderField(field) : null;
            })}
          </React.Fragment>
        ))}

        {renderUnitField(
          'distanceUnit',
          distanceUnitOptions,
          'distanceUnitLabel',
          'distanceUnitRequired',
          'distanceUnitTooltip'
        )}
      </div>

      {/* Weight row */}
      <div className={css.formRow}>
        {[['weight']].map((pair, idx) => (
          <React.Fragment key={`wt-block-${idx}`}>
            {pair.map(fieldName => {
              const field = fields.find(f => f.name === fieldName);
              return field ? renderField(field) : null;
            })}
          </React.Fragment>
        ))}

        {renderUnitField(
          'massUnit',
          weightUnitEnum,
          'weightUnitLabel',
          'weightUnitRequired',
          'weightUnitTooltip'
        )}
      </div>
    </div>
  );
};

export default PackageDimensionSection;
